<template>
  <div class="crm-button">
    <div :class="[buttonType, size]">
      <el-button
        :size="size"
        :disabled="disabled"
        :loading="loading"
        @click="handleClick"
      >
        <i :class="icon"></i>
        {{ text }}
        <slot></slot>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  /**
   * @Component 按钮组件
   * @Params { String } buttonType 按钮类型 主要primary、次要secondary、危险danger、朴素plain
   * @Params { String } size 按钮规格 default(弹窗)、主要mini、small(侧面板内按钮)
   * @Return { String } text 按钮文字
   * @Return { String } icon element的icon的class名
   */
  name: 'crmButton',
  props: {
    buttonType: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'small',
    },
    text: {
      type: String,
    },
    icon: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-button {
  display: inline-block;
  margin-left: 10px;
  .el-button {
    border: none;
    color: @color--white;
    &:focus,
    &:hover {
      color: @color--white;
      border: none;
    }
  }
  // 颜色样式
  .primary {
    .el-button {
      background-color: @bg--primary;
    }
  }
  .info {
    .el-button {
      background-color: @bg--info;
    }
  }
  .secondary {
    .el-button {
      background-color: @bg--secondary;
    }
  }
  .danger {
    .el-button {
      background-color: @bg--danger;
    }
  }
  .plain {
    .el-button {
      border: @border--plain;
      background-color: @bg--plain;
      color: @color--placeholder;
    }
    &:focus,
    &:hover {
      color: @color--placeholder;
    }
  }
  // 规格
  .default {
    .el-button {
      min-width: @mw-default;
    }
  }
  .mini {
    .el-button {
      min-width: @mw-mini;
    }
  }
  .small {
    .el-button {
      min-width: @mw-small;
    }
  }
}
</style>
